import { memo, useEffect, useState } from 'react';
import styles from './index.less';
import QuickOperation from '@/pages/Home/components/QuickOperation';
import StickyBottom from '@/components/StickyBottom';
import Majordomo from '@/pages/Home/components/Majordomo';
import AddCommunityTip from '@/pages/Home/components/AddCommunityTip';
import Information from '@/pages/Home/components/Information';
import MaskDialog from '@/components/MaskDialog';
import SelectCommunity from '@/components/SelectCommunity';
import AddHouseMaskDialog from '@/components/AddHouseMaskDialog';
import Banner from '@/pages/Home/components/Banner';
import { Helmet, history, useModel } from '@umijs/max';
import { ArrowDown } from '@react-vant/icons';
import './index.less';
import { getWechatActivityList, getWechatNewsList } from '@/service/banner';
import BindHouse from '../Mine/My/components/BindHouse';



const Home = () => {
  const [WechatNewsList, setWechatNewsList] = useState<[]>([]);
  const [WechatActivityList, setWechatActivityList] = useState<[]>([]);
  const [maskDialogVisible, setMaskDialogVisible] = useState<boolean>(false);
  const [selectCommunityVisible, setSelectCommunityVisible] = useState<boolean>(false);
  const [addHouseMaskDialogVisible, setAddHouseMaskDialogVisible] = useState<boolean>(false);

    const [bindHouseVisible, setBindHouseVisible] = useState<boolean>(false);
    const { roomList, queryInformation, defaultRoom, bindInformation, ownerInformation } = useModel(
      'useDefaultRoom',
      (model) => ({
        ownerInformation: model.ownerInformation,
        roomList: model.roomList,
        queryInformation: model.queryInformation,
        defaultRoom: model.defaultRoom,
        bindInformation: model.bindInformation,
      }),
    );
  
  console.log(77,  ownerInformation)




  const checkBindRoom = () => {
    return (
      bindInformation?.car === '0' &&
      bindInformation?.room === '0' &&
      bindInformation?.park === '0'
    );
  };

  useEffect(() => {
    console.log('bindInformation', bindInformation)
    if ( bindInformation && checkBindRoom()) {
      setAddHouseMaskDialogVisible(true);
    } else {
      setAddHouseMaskDialogVisible(false);
    }
  }, [bindInformation]);


  useEffect(() => {
    getWechatNewsList({ pageNum: 1, pageSize: 1000, communityId: defaultRoom?.communityId,  status:'1' }).then((res) => {
      if (res && res.code === 200) {
        const data = res.rows
        setWechatNewsList(data.length > 2 ? data.slice(0, 2) || [] : data);
      }
      
    });

    getWechatActivityList({ pageNum: 1, pageSize: 1000, communityId: defaultRoom?.communityId, status:'1' }).then((res) => {
      if (res && res.code === 200) {
        const data = res.rows
        setWechatActivityList(data.length > 2 ? data.slice(0, 2) || [] : data);
      }
    });
  }, [defaultRoom]);

  const closeSelectCommunity = (value: boolean) => {
    setSelectCommunityVisible(value);
    // handleQueryBindCommunity();
  };

  const openMaskDialog = () => {
    setMaskDialogVisible(true);
  };

  const openSelectCommunity = () => {
    setSelectCommunityVisible(true);
    
  };

  const openAddHouse = () => {
    setBindHouseVisible(true)
  }

  const handleQuickClick = (value: string) => {
    if (value !== '') {
      // 活动和资讯不绑定房屋也可以查看
      if ((value.indexOf('wechatActivity') === -1 && value.indexOf('wechatNews') === -1) && checkBindRoom()) {
        setAddHouseMaskDialogVisible(true);
      } else {
        history.push(value);
      }
      
      
    } else {
      openMaskDialog();
    }
  };

  const handleClick = (item: any) => {
    console.log(item);
    if (item && item.urlPath) {
      history.push(item.urlPath);
    }
  };

  const openTip = () => {
    setAddHouseMaskDialogVisible(true);
  }

  return (
    <div className={styles.container}>
      <Helmet>
        <title>首页</title>
      </Helmet>
      <div className={styles.header}>
        <div className={styles['header-select']}>
          
          <div onClick={openSelectCommunity}>
            {defaultRoom
              ? `${defaultRoom.communityName}:${defaultRoom.roomCode}`
              : '请选择房屋'}{' '}
            <ArrowDown />
          </div>
        </div>

        {/* <div onClick={openMaskDialog} className={styles['header-title']}>
          <p>智慧·物业</p>
          <span>让物业管理更方便</span>
        </div> */}
      </div>
      <Banner defaultRoom={defaultRoom}></Banner>
      <QuickOperation quickClick={handleQuickClick} />
      <Majordomo bindInformation={bindInformation} open={openTip} />
      <Information
        click={handleClick}
        title="社区资讯"
        list={WechatNewsList}
        type="1"
        key="2"
      />
      <Information
        click={handleClick}
        title="社区活动"
        list={WechatActivityList}
        type="2"
        key="1"
      />
      {roomList.length === 0 && (
        <AddCommunityTip btnClick={openAddHouse} />
      )}
      <SelectCommunity
        visible={selectCommunityVisible}
        close={closeSelectCommunity}
      />
      <AddHouseMaskDialog
        visible={addHouseMaskDialogVisible}
        close={setAddHouseMaskDialogVisible}
        btnClick={openAddHouse}
      />
      <MaskDialog visible={maskDialogVisible} close={setMaskDialogVisible} />
      <StickyBottom activeKey={'home'} />
      <BindHouse
          visible={bindHouseVisible}
          close={() => setBindHouseVisible(false)}
        />
    </div>
  );
};

export default Home;
